<template>
    <div
        id="app"
        v-cloak
    >
        <navbar v-cloak />
        <mobile-nav v-cloak />

        <transition
            name="fade"
            mode="out-in"
        >
            <router-view v-cloak />
        </transition>
 
        <site-footer v-cloak />
    </div>
</template>


<script>
import Navbar from '@/components/navbar';
import MobileNav from '@/components/mobile-nav';
import SiteFooter from '@/components/site-footer';
import Axios from 'axios';

export default {
    name: 'App',
    components: { Navbar, MobileNav, SiteFooter },
    data() {
        return {};
    },
    mounted() {
        this.ensureSessionLink();
        this.loadChat();
    },
    methods: {
        /**
         * This method checks to see if a PHP session
         * cookie exists. If not, it sends a request
         * to initiate a session.
         * 
         * This is necessary during the transition period
         * whilst Vue is running alongside the old-monolithic
         * site to allow Vue to act upon session data in PHP.
         */
        async ensureSessionLink() {
            // 1st, check for a session. Return true if set.
            const sessId = window.$cookies.get('PHPSESSID');
            if (typeof sessId !== 'undefined' && sessId !== null) {
                return true;
            }

            // 2nd, if no session is set, initiate one.
            try {
                const response = await Axios
                    .head('https://www.ecowebhosting.co.uk/order/ajax_runners/initiateSession.php');
                return response.data;
            } catch (error) {
                this.$root.$emit('axios-error', {
                    message: `Couldn't initiate a background PHP session: ${error}`,
                });
                return false;
            }
        },
        loadChat() {
            var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
            (function(){
                var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
                s1.async=true;
                s1.src='https://embed.tawk.to/57bb0a2b311d6c5be04e2ce7/default';
                s1.charset='UTF-8';
                s1.setAttribute('crossorigin','*');
                s0.parentNode.insertBefore(s1,s0);
            })();
        },
    },
};
</script>

<style lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to {
        opacity: 0
    }
    [v-cloak] {
        opacity: 0;
        visibility: hidden;
        transition: visibility 0s 5s, opacity 5s linear;
    }
</style>

<style lang="css" src="./assets/fonts/0E37AE980949E1537.css?family=gotham:400,700">
</style>

<style lang="scss" src="./materialize.scss"></style>
<style lang="scss" src="./sass/main.scss"></style>


      